import React from 'react';
import {isMobile, isIOS} from 'react-device-detect';

declare global {
    interface Window { gtag: any}
}

const LandingPage: React.FC = () => {

    const store_ios: any     = isMobile ? process.env.REACT_APP_STORES_IOS_MOBILE_URL : process.env.REACT_APP_STORES_IOS_WEB_URL;
    const store_android: any = isMobile ? process.env.REACT_APP_STORES_ANDROID_MOBILE_URL : process.env.REACT_APP_STORES_ANDROID_WEB_URL;
    const store_hauwei: any  = isMobile ? process.env.REACT_APP_STORES_HUAWEI_MOBILE_URL : process.env.REACT_APP_STORES_HUAWEI_WEB_URL;

    const zapperUrl: any = isIOS ? process.env.REACT_APP_PROTOCOLS_IOS : process.env.REACT_APP_PROTOCOLS_ANDROID;
    const device: string = isMobile ? 'Mobile' : 'Desktop';

    const sendGoogleAnlyticsEvent = (device: string, action: string, outcome: string) => {
        window.gtag("event", action, {
            device: device,
            outcome: outcome
        });
	}

    if(isMobile){
        const storeName: string = isIOS ? 'App Store' : 'Play Store';
        sendGoogleAnlyticsEvent(device, 'Redirect', storeName);
        window.location.href = isIOS ? store_ios : store_android;
    }

    return (
        <div className="base bg-brand text-base text-white relative overflow-hidden flex min-h-screen">
            <img src={`${process.env.PUBLIC_URL}/img/zapper-phone.png`} alt="" className="phone hidden lg:block" />
            <div className="flex w-full">
                <div className="w-full lg:w-2/5 lg:ml-auto flex items-center justify-center relative">
                    <div className="w-3/4 lg:w-auto flex flex-col items-center self-center my-16">
                        <div className="ie-svg-fix">
                            <img src={`${process.env.PUBLIC_URL}/img/zapper-app-icon.svg`} className="mx-auto app-icon" alt="Zapper" />
                        </div>
                        <h1 className="text-4xl lg:text-[40px] font-medium leading-snug lg:leading-[48px] text-center mt-8 mb-12 lg:mb-16">Get the free<br />Zapper app<br />today</h1>
                        <a href={store_ios} onClick={() => {sendGoogleAnlyticsEvent(device, 'Click', 'App Store')}}><img src={`${process.env.PUBLIC_URL}/img/badge-app-store.svg`} alt="Download on the App Store" className="store-badge mx-auto mb-4" /></a>
                        <a href={store_android} onClick={() => {sendGoogleAnlyticsEvent(device, 'Click', 'Play Store')}}><img src={`${process.env.PUBLIC_URL}/img/badge-google-play.svg`} alt="Get it on Google Play" className="store-badge mx-auto mb-4" /></a>
                        <a href={store_hauwei} onClick={() => {sendGoogleAnlyticsEvent(device, 'Click', 'App Gallery')}}><img src={`${process.env.PUBLIC_URL}/img/badge-app-gallery.svg`} alt="Explore it on AppGallery" className="store-badge mx-auto" /></a>
                        <p className="text-center lg:hidden mt-10">Already have the Zapper app?
                            <br /><a href={zapperUrl} onClick={() => {sendGoogleAnlyticsEvent(device, 'Click', 'Open Zapper')}} className="font-bold underline">Open now</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LandingPage;